// extracted by mini-css-extract-plugin
module.exports = {"methodsListsBlocksListHeader":"MethodsListsBlocksListHeader_methodsListsBlocksListHeader__2nYyz"};